import { Component, ReactNode } from 'react';

export default class Header extends Component {
  constructor(readonly props: Readonly<{ isLarge?: boolean }>) {
    super(props);
  }

  render(): ReactNode {
    return (
      <div
        className={`spinner-border spinner-border-${this.props?.isLarge ? '' : 'sm'}`}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }
}
